export default __webpack_public_path__ + "resources/icons/d210-e92b.png";